module.exports = __webpack_public_path__ + "assets/img/CuentaLogoOnlyMain.c9cc4d0b.png";